import { Process } from '@app/shared/models/process/process.model';
import { Workflow } from '@app/shared/models/workflow.model';
import { localDateToString } from '@app/shared/transformers/local-date-to-string.transformer';
import { IsNullable } from '@webmozarts/http-client';
import { Transform, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDefined, IsEnum } from 'class-validator';

function hasDatePassed(date: Date | null): boolean {
    const now = new Date();

    return null === date || date < now;
}

export function isGrowingSeasonSince(growingSeasonId: string, year: number): boolean {
    return Number(growingSeasonId) >= year;
}

export class CertificationPreview {
    @IsDefined()
    id!: string;

    @IsDefined()
    globalId!: string;

    @IsDefined()
    summary!: string;
}

export class Certification extends CertificationPreview {

    @IsDefined()
    growingSeasonId!: string;

    @IsDefined()
    @IsEnum(Workflow)
    @Type()
    workflow!: Workflow;

    @IsDefined()
    @IsBoolean()
    skipAdvanceNotification!: boolean;

    @IsDefined()
    @Transform(localDateToString)
    @IsNullable()
    availableFrom!: Date | null;

    @IsDefined()
    @Transform(localDateToString)
    @IsNullable()
    officialAdvanceNotificationDeadline!: Date | null;

    @IsDefined()
    @Transform(localDateToString)
    @IsNullable()
    officialCertificationRequestDeadline!: Date | null;

    @IsDefined()
    @Transform(localDateToString)
    @IsNullable()
    actualAdvanceNotificationDeadline!: Date | null;

    @IsDefined()
    @Transform(localDateToString)
    @IsNullable()
    actualCertificationRequestDeadline!: Date | null;

    @IsDefined()
    @Transform(localDateToString)
    @IsNullable()
    certificationRequestAvailableFrom!: Date | null;

    @IsDefined()
    hasGoal!: boolean;

    @IsDefined({ each: true })
    @IsArray()
    permittedProcessIds!: string[];

    @IsDefined({ each: true })
    @IsArray()
    mandatoryProcessIds!: string[];

    @IsDefined()
    title!: string;

    get isAvailableNow(): boolean {
        return hasDatePassed(this.availableFrom);
    }

    get isCertificationRequestAvailableNow(): boolean {
        return hasDatePassed(this.certificationRequestAvailableFrom);
    }

    isMandatoryProcess(process: Process): boolean {
        return this.mandatoryProcessIds.includes(process.id);
    }

    isPermittedProcess(process: Process): boolean {
        return this.permittedProcessIds.includes(process.id);
    }

    isOptionalProcess(process: Process): boolean {
        return this.isPermittedProcess(process)
            && !this.isMandatoryProcess(process);
    }

    isGrowingSeasonSince(year: number): boolean {
        return isGrowingSeasonSince(this.growingSeasonId, year);
    }
}
